export default {
  appendStep: 'Pridať krok na koniec',
  insertStep: 'Vložiť krok pred',
  stepMoveUp: 'Presunúť nahor',
  stepMoveDown: 'Presunúť nadol',
};
